import { Auth } from 'aws-amplify';
import { useCallback, useRef, useState } from 'react';
import { checkIsSameUser, getWebViewAuthTokens, signInWithTokens } from './signInWithTokens';
import { useFujiAuth } from './useFujiAuth';
/**
 * 自動的にWebViewからのサインインを試みるEffect
 */
export const useWebViewAutoSignIn = () => {
    const { isAuthenticated } = useFujiAuth();
    const [isInitialized, setIsInitialized] = useState<boolean>(false);
    const isRunningRef = useRef<boolean>(false);

    const autoSignIn = useCallback(async () => {
        try {
            if (isInitialized || isRunningRef.current) {
                return;
            }
            isRunningRef.current = true;
            // トークンをWebViewから取得
            const authToken = getWebViewAuthTokens();
            if (authToken == null) {
                // WebViewからのアクセスではない、またはトークンが取得できなかった場合
                return;
            }

            if (isAuthenticated) {
                // 既に認証済みの場合はサインアウトしてから再度サインインを行う。
                const isSameUser = await checkIsSameUser(authToken);
                if (!isSameUser) {
                    await Auth.signOut();
                }
            }
            // 自動サインインを行う。
            await signInWithTokens(authToken);
        } catch (error) {
            console.error('Error during WebView auto sign-in:', error);
        } finally {
            setIsInitialized(true);
            isRunningRef.current = false;
        }
    }, [isAuthenticated]);

    return { autoSignIn, isInitialized };
};
